import { isAxiosError } from 'axios';
import { apiClient } from '@/axios';
import { Endpoints } from '@/enums';

type ApiResponseValue = {
  oidVisita: number;
  cutoff: string;
  playa: string | null;
  llego: string | boolean | null;
  tipo: string | null;
  isSuccess: boolean;
  exception: {
    message: string;
  };
};

type ApiResponse = {
  isSuccess: boolean;
  value: ApiResponseValue;
};

type Query = {
  marca: string;
  numero: string;
};

export const getOidVisita = async (query: Query): Promise<ApiResponseValue> => {
  try {
    const res = await apiClient.post<ApiResponse>(
      Endpoints.ObtainVisita,
      query
    );
    const { isSuccess, value } = res.data;
    if (!isSuccess || value?.isSuccess === false)
      throw new Error(
        value?.exception?.message ||
          'No se ha podido obtener el oid de la visita'
      );

    return res.data?.value;
  } catch (error) {
    if (isAxiosError(error)) {
      throw new Error(error.message);
    }
    throw error;
  }
};
